import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import {
  UIButton,
  UIPaginationBar,
} from "../../../components/ui";
import TeamToolbar from "../../Company-portal/TeamsPermissions/TeamToolbar";
import RolesTable from "../../Company-portal/TeamsPermissions/RolesTable";
import DeleteRoleModal from "../../Company-portal/TeamsPermissions/DeleteRoleModal";
import TeamListEmptyState from "../../Company-portal/TeamsPermissions/TeamListEmptyState";
import useAdminCompanyRolesList from "./hooks/useAdminCompanyRolesList";

const AdminRolesManagement = ({ companyId }) => {
  const {
    copy,
    rolesCopy,
    search,
    debouncedSearch,
    rows,
    page,
    pageSize,
    pages,
    rangeFrom,
    rangeTo,
    total,
    isLoading,
    roleToDelete,
    pageSizeOptions,
    canAdd,
    canEdit,
    canDelete,
    handleSearchChange,
    handlePageChange,
    handlePageSizeChange,
    handleToggleStatus,
    handleCreateRole,
    handleViewRole,
    handleEditRole,
    handleDeleteRole,
    closeDeleteModal,
    confirmDeleteRole,
  } = useAdminCompanyRolesList(companyId);

  if (isLoading && !rows.length) {
    return null;
  }

  return (
    <Box className="team-management__panel">
      <TeamToolbar
        search={search}
        searchPlaceholder={rolesCopy.searchPlaceholder}
        onSearchChange={handleSearchChange}
      >
        {canAdd && (
          <UIButton
            variant="outlined"
            size="large"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleCreateRole}
            className="team-management__add"
          >
            {rolesCopy.createRole}
          </UIButton>
        )}
      </TeamToolbar>

      {rows.length ? (
        <>
          <RolesTable
            rows={rows}
            pageSize={pageSize}
            labels={rolesCopy.table}
            onView={handleViewRole}
            onToggleStatus={handleToggleStatus}
            onEdit={handleEditRole}
            onDelete={handleDeleteRole}
            canEdit={canEdit}
            canDelete={canDelete}
          />
          <UIPaginationBar
            currentPage={page}
            pages={pages}
            pageSize={pageSize}
            pageSizeOptions={pageSizeOptions}
            rangeTemplate={rolesCopy.rangeTemplate}
            rangeFrom={rangeFrom}
            rangeTo={rangeTo}
            rangeTotal={total}
            rowsPerPageLabel={copy.rowsPerPageLabel}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </>
      ) : (
        <TeamListEmptyState
          searchTerm={debouncedSearch}
          total={total}
          copy={rolesCopy}
          canAdd={canAdd}
          actionLabel={rolesCopy.createRole}
          onAction={handleCreateRole}
        />
      )}

      <DeleteRoleModal
        open={Boolean(roleToDelete)}
        role={roleToDelete}
        copy={rolesCopy.deleteModal}
        onClose={closeDeleteModal}
        onConfirm={confirmDeleteRole}
      />
    </Box>
  );
};

AdminRolesManagement.propTypes = {
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default AdminRolesManagement;
